import React from 'react';
import GlobalMain from 'molecules/Main/GlobalMain';
import { PageProps } from 'gatsby';
import Feed from 'sections/Homepage/Feed/Feed';
import HeroBanner from 'sections/experiments/homepage_hero_headline_change/Homepage/HeroBanner/HeroBanner';
import TestimonialsFeed from 'sections/Homepage/TestimonialsFeed/TestimonialsFeed';
import Calculator from 'sections/Homepage/Calculator/Calculator';
import EmpifyTestimonial from 'sections/Homepage/EmpifyTestimonial/EmpifyTestimonial';
import CategoryPiratesTestimonial from 'sections/Homepage/CategoryPiratesTestimonial/CategoryPiratesTestimonial';
import FeaturesCall from 'sections/Homepage/FeaturesCall/FeaturesCall';
import Pricing from 'sections/Homepage/Pricing/Pricing';
import FeaturesList from 'sections/Homepage/FeaturesList/FeaturesList';
import Integrations from 'sections/Homepage/Integrations/Integrations';
import GetToKnowUsBetter from 'sections/Homepage/GetToKnowUsBetter/GetToKnowUsBetter';
import SocialProof from 'sections/Homepage/SocialProof/SocialProof';
import CallToAction from 'sections/Homepage/CallToAction/CallToAction';
import TrustedLogos from 'sections/Homepage/TrustedLogos/TrustedLogos';
import BrandedApp from 'sections/Homepage/BrandedApp/BrandedApp';
import getQueryParams from 'src/functions/getQueryParams';
import { TopInfoBarControllerProvider } from 'src/hooks/useTopInfoBarController';

const HomepageView = (props: PageProps): JSX.Element => {
  const renderView = () => (
    <GlobalMain location={props.location}>
      <HeroBanner />
      <Feed />
      <Calculator />
      <FeaturesCall />
      <FeaturesList />
      <TestimonialsFeed />
      <EmpifyTestimonial />
      <TrustedLogos />
      <Integrations />
      <Pricing />
      <BrandedApp />
      <CategoryPiratesTestimonial />
      <GetToKnowUsBetter />
      <SocialProof />
      <CallToAction />
    </GlobalMain>
  );

  const renderWithInactiveNetwork = () => (
    <TopInfoBarControllerProvider
      visible
      dismissible
      contentLayout='inactiveNetworks'
    >
      {renderView()}
    </TopInfoBarControllerProvider>
  );

  const renderWithPeopleMagicProfitAnnouncement = () => (
    <TopInfoBarControllerProvider
      visible
      dismissible
      contentLayout='peopleMagicProfitAnnouncement'
      dismissKey='dismissedPeopleMagicProfitAnnouncement_1'
    >
      {renderView()}
    </TopInfoBarControllerProvider>
  );

  if (getQueryParams()['inactive_network'] === '1') {
    return renderWithInactiveNetwork();
  }

  return renderWithPeopleMagicProfitAnnouncement();
};

export default HomepageView;
